module.exports = __webpack_public_path__ + "static/media/BebasNeue-Regular.9ab0544d.woff2";